import React from 'react';
import Select from 'react-select';
import { CFormCheck } from '@coreui/react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const dataTypeOptions = [
    { value: 'string', label: 'String' },
    { value: 'numeric', label: 'Numeric' },
    { value: 'boolean', label: 'Boolean' },
    { value: 'timestamp', label: 'Timestamp' },
];
const requiredOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
];

const FieldRow = React.memo(function FieldRow({
    field,
    idx,
    stepsData,
    setFieldValue,
    isMoreThanOneTrue,
}) {
    const stepsObjects = Array.isArray(stepsData?.objects) ? stepsData.objects : [];
    const mergedValues = stepsObjects.length > 0
        ? stepsObjects.flatMap(({ id, name, ...rest }) =>
            Object.values(rest ?? {}).flatMap((v) =>
                Array.isArray(v) ? v : v != null ? [v] : []
            )
        )
    : [];

    const valStrArr = Array.isArray(field.example)
        ? field.example
        : (field.example || '').split(',');

    return (
        <tr>
            <td className="align-middle" style={{ maxWidth: 300 }}>
                <div className='d-flex flex-wrap gap-1'>
                    <span>{field.fieldName}</span>
                    {field.isNew && (
                        <span
                            style={{
                                color: '#fff',
                                background: '#ff9800',
                                borderRadius: 8,
                                padding: '2px 8px',
                                fontSize: 12,
                                fontWeight: 600,
                                verticalAlign: 'middle'
                            }}
                        >
                            New!
                        </span>
                    )}
                </div>
            </td>
            <td className="align-middle">
                <Select
                    value={dataTypeOptions.find(opt => opt.value === field.dataType)}
                    options={dataTypeOptions}
                    onChange={opt => setFieldValue(`fields[${idx}].dataType`, opt.value)}
                    isDisabled={stepsData.isImported || (isMoreThanOneTrue && !field.isNew)}
                    className="width_150"
                    classNamePrefix="react-select"
                />
            </td>
            <td className="align-middle">
                <Select
                    value={requiredOptions.find(opt => opt.value === field.required)}
                    options={requiredOptions}
                    onChange={opt => {
                        setFieldValue(`fields[${idx}].required`, opt.value);
                        if (opt.value === 'yes') {
                            setFieldValue(`fields[${idx}].ignore`, false);
                        }
                    }}
                    className="width_150"
                    classNamePrefix="react-select"
                />
            </td>
            <td style={{ maxWidth: 300 }}>
                <ul className="mb-0 mw-300 d-inline-flex flex-column pl-0">
                    {valStrArr.map((val, i) => {
                        const v = (val !== undefined && val !== null) ? String(val).trim() : '';

                        return (
                            <Tippy
                                key={i}
                                content={v}
                                placement='bottom'
                                interactive={true}
                            >
                                <li
                                    className="text-muted hover-show-tooltip"
                                    style={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        width: '100%',
                                    }}
                                >{v}</li>
                            </Tippy>
                        )
                    })}
                </ul>
            </td>
            <td className="text-center align-middle pb-4">
                <CFormCheck
                    checked={field.ignore}
                    disabled={field.required === 'yes' || stepsData.isImported || mergedValues.includes(field.fieldName)}
                    onChange={e => setFieldValue(`fields[${idx}].ignore`, e.target.checked)}
                />
            </td>
        </tr>
    );
}, (prev, next) => (
    prev.field === next.field
    && prev.idx === next.idx
    && prev.setFieldValue === next.setFieldValue
));

export default FieldRow;
